import { defineMessages } from 'react-intl-next';

export const messages: {
	progress: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	progress: {
		id: 'twc.xflow.modal.progress',
		defaultMessage:
			'Getting your collection ready—this will only take a moment. You will be redirected shortly.',
		description: 'Message displayed when provisioning is in progress',
	},
});
